// extracted by mini-css-extract-plugin
export default {"promoCodeLabel":"PromoCodeLabel-module__promoCodeLabel___1pCQz"};